import { BulkPositionCreatorPage } from '@/modules/bulkPositionCreator/BulkPositionCreatorPage.tsx';

export function BulkPositionCreatorRoute() {
    return <BulkPositionCreatorPage />;
}
